module.exports = __webpack_public_path__ + "assets/images/time-to-growth-icon.dfb496f7a01f3d1498089e0de0e2d16c.svg";